export default {
  "b2b.zdroje-grid-columns.id.label": "Id",
  "b2b.zdroje-grid-columns.nazev.label": "Name",
  "b2b.zdroje-grid-columns.popis.label": "Description",
  "b2b.zdroje-grid-columns.exkluzivita.label": "Exclusive",
  "b2b.zdroje-grid-columns.maxPocetPozadavku.label": "Max. requests",
  "b2b.zdroje-grid-columns.pozadavekSmena.label": "Shift required"
};
